/**
 * @description 查詢連接 URL 類別用
 */
export enum LinkCategory {
    Header = 'header',
    Footer = 'footer',
    Service = 'service',
    Doc = 'doc',
    TravelDoc = 'traveldoc',
    CarDoc = 'cardoc',
    MotoDoc = 'motodoc',
    FireDoc = 'firedoc',
    PetDoc = 'petdoc',
    Activity = 'activity',
    Regdoc = 'regdoc',
    DocRescure = 'doc_rescure',
    Mobdevdoc = 'mobdevdoc',
    /** 行動裝置險-上傳檔案範例 */
    DocMphpcug = 'doc_mphpcug',
    /** 車險資料預覽頁條款 */
    I02TERMS2 = 'I02TERMS2',
    I03TERMS2 = 'I03TERMS2',
    /** 理賠服務上傳檔案範例 */
    DocCompensation = 'doc_compensation',
}
